export const INFO_EMAIL = 'info@clearh2owindowcleaning.co.uk';
export const CONTACT_EMAIL = 'clear.h2o@live.co.uk';
export const CONTACT_PHONE = '+44 (0)7974 872 772';
export const OFFICE_PHONE = '+44 (0)1256 479453';
export const WEBSITE_URL = 'https://book-clear-h2o.web.app';

export const EXTERNAL_URL = {
    STRIPE: 'https://stripe.com',
    TERMS: `${window.location.origin}/terms-and-conditions`,
    PRIVACY: `${window.location.origin}/privacy-policy`,
    CHECKATRADE_PROFILE: 'https://www.checkatrade.com/ClearH20WindowCleaningService/',
    MY_WEBSITE: 'https://clearh2owindowcleaning.co.uk',
};
